/*LIBRARY*/
import { connect } from "react-redux";

/*COMPONENT*/
import LayerListModeButton from "../editor_sidebar/LayerListModeButton";
import LayerListModeExpand from "../editor_sidebar/LayerListModeExpand";

/*REDUX*/

/*PICTURE*/

/*FUNCTION*/

/*DATA*/

/*CONST*/

const LAYER_LIST = ({ project }) => {
  const { geo_project } = project;

  return (
    <main style={{ marginBottom: "200px" }}>
      {geo_project.mode_folder === "button" ? (
        <LayerListModeButton />
      ) : (
        <LayerListModeExpand />
      )}
    </main>
  );
};

const map_state_to_props = (state) => ({
  project: state.project,
});

export default connect(map_state_to_props, {})(LAYER_LIST);
